import { isNumber } from 'lodash-es';

import { Timecode } from '@iconik-io/core/src/timecode';

import { zeroTimecode } from './constants/timecode';
import type { TimecodeOptions } from './get_proxy_timecode_options';

type Parameters = {
  startMilliseconds: number | null | undefined;
  endMilliseconds: number | null | undefined;
  timecodeOptions: TimecodeOptions;
};

export const rangeToSmpteString = ({
  startMilliseconds,
  endMilliseconds,
  timecodeOptions,
}: Parameters): string => {
  let result = '';
  const startTimecodeObject = new Timecode(timecodeOptions, {
    smpte: timecodeOptions.startTimecode ?? zeroTimecode,
  });
  const startTimecodeSeconds = startTimecodeObject.toSeconds();

  if (isNumber(startMilliseconds)) {
    const start = new Timecode(timecodeOptions, {
      seconds: startTimecodeSeconds + startMilliseconds / 1000,
    });
    result = start.toSMPTE();
  }

  if (isNumber(endMilliseconds)) {
    const end = new Timecode(timecodeOptions, {
      seconds: startTimecodeSeconds + endMilliseconds / 1000,
    });
    result = `${result} - ${end.toSMPTE()}`;
  }

  return result;
};
